export type Matrix3 = number[];
export type Vector2 = number[];

export const Identity3D = [ 1, 0, 0, 0, 1, 0, 0, 0, 1];

export function multiplyVectorMatrix(v: Vector2, m: Matrix3): Vector2 {
    let x = v[0], y = v[1], z = v[2] || 1;

    return [
        x * m[0] + y * m[3] + z * m[6],
        x * m[1] + y * m[4] + z * m[7],
        x * m[2] + y * m[5] + z * m[8]
    ];
}

export function multiplyMatrixMatrix(m: Matrix3, n: Matrix3): Matrix3 {
    let m0 = m[0], m1 = m[1], m2 = m[2],
        m3 = m[3], m4 = m[4], m5 = m[5],
        m6 = m[6], m7 = m[7], m8 = m[8];

    let n0 = n[0], n1 = n[1], n2 = n[2],
        n3 = n[3], n4 = n[4], n5 = n[5],
        n6 = n[6], n7 = n[7], n8 = n[8];

    return [
        m0 * n0 + m1 * n3 + m2 * n6,
        m0 * n1 + m1 * n4 + m2 * n7,
        m0 * n2 + m1 * n5 + m2 * n8,

        m3 * n0 + m4 * n3 + m5 * n6,
        m3 * n1 + m4 * n4 + m5 * n7,
        m3 * n2 + m4 * n5 + m5 * n8,

        m6 * n0 + m7 * n3 + m8 * n6,
        m6 * n1 + m7 * n4 + m8 * n7,
        m6 * n2 + m7 * n5 + m8 * n8
    ];
}

export function multiplyMatrices(ms: Array<Matrix3>): Matrix3 {
    if (!ms) {
        throw Error("ms: argument can't be null");
    }
    if (ms.length > 0) {
        let m = ms[0];
        for (let i = 1 ; i < ms.length ; i++) {
            m = multiplyMatrixMatrix(m, ms[i]);
        }
        return m;
    }
    return Identity3D;
}

export class MatrixBuilder3 {
    constructor(private m: Matrix3 = Identity3D) {}

    public scale(x: number, y: number) : this {
        this.m = multiplyMatrixMatrix(this.m, [
            x, 0, 0,
            0, y, 0,
            0, 0, 1
        ]);
        return this;
    }

    public rotate(a: number) : this {
        this.m = multiplyMatrixMatrix(this.m, [
            Math.cos(a), Math.sin(a), 0,
           -Math.sin(a), Math.cos(a), 0,
                      0,           0, 1
                    ]);
        return this;
    }

    public translate(x: number, y: number) : this {
        this.m = multiplyMatrixMatrix(this.m, [
            1, 0, 0,
            0, 1, 0,
            x, y, 1
        ]);
        return this;
    }

    public build() : Matrix3 {
        return this.m;
    }
}